import Image from 'next/image';
import Link from 'next/link';
import { formatDate } from '@/utils/formatDate';
import imageblog from '@/assets/image/blogs/blog-image.png'

export default function BlogsCard({ blogData }: any) {
  const category = blogData?.categories?.[0]?.category_name ?? null;

  return (
    <div className="flex max-h-full min-h-80 p-6 font-montserrat shadow-lg">
      <div className="flex flex-col gap-2 ">
        {/* Featured Image */}
        <Image
          src={blogData?.featured_image?.url ?? imageblog}
          alt={blogData?.blog_title ?? "Featured-image"}
          width={500}
          height={250}
          className="h-52 min-h-52 w-full object-fill"
        />
        <div className="my-2 flex h-full flex-col justify-between gap-y-2">
          {category && <p className="text-sm font-medium text-[#6941C6]">{category}</p>}

          <div className="space-y-3">
            <div className="font-semibold leading-tight text-tertiary md:text-base">
              <Link href={`/blogs/${blogData?.blog_url}`} className="flex items-center gap-x-2">
                <p className="line-clamp-2">{blogData?.blog_title}</p>
                <span>{/* <RightArrowBlackIcon className="-rotate-45" /> */}</span>
              </Link>
            </div>

            {/* <p className="text-gray-500 md:leading-snug line-clamp-3 text-sm">
              {blogData?.description ?? blogData?.excerpt}
            </p> */}
          </div>
          {/* <div className="flex justify-between items-center text-white"> */}

          <div className="flex items-center gap-x-3 pt-3">
            {(blogData?.updated_by_user?.profile_picture?.url || blogData?.created_by_user?.profile_picture?.url) && (
              <Image
                src={blogData?.updated_by_user?.profile_picture?.url ?? blogData?.created_by_user?.profile_picture?.url}
                alt={blogData?.updated_by_user?.name}
                className="size-8 rounded-full bg-gray-100 object-cover"
                width={40}
                height={40}
              />
            )}

            <div className="">
              <p className="text-sm font-medium text-[#183B56]">
                {blogData?.updated_by_user?.name ??
                  blogData?.created_by_user?.name ??
                  blogData?.author_name ??
                  'Tanya Verma'}
              </p>
              <div className="text-xs text-gray-500">{formatDate(blogData?.updatedAt)}</div>
              {/* <div className="flex gap-2 text-xs md:text-sm">
                  <VerifiedIcon />
                  <p className="italic text-[#5A7184]">Verified</p>
                </div> */}
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
